import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
import { registerWxConfig } from "@/weixinConfig.js";
// 修改首页路由重复点击报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const $router = new VueRouter({
  routes: [
    // {
    //   path: "/",
    //   name: "index",
    //   component: (resolve) => require(["@/views/index/index.vue"], resolve),
    //   children: [],
    // },

    {
      path: "/",
      name: "index",
      redirect: "/course",
      component: (resolve) => require(["@/views/index"], resolve),
      children: [
        {
          path: "course",
          name: "course",
          component: (resolve) =>
            require(["@/views/parent-course/index"], resolve),
        },
        {
          path: "testCenter",
          name: "test-center",
          component: (resolve) =>
            require(["@/views/test-center/index"], resolve),
        },
        {
          path: "growGroup",
          name: "grow-group",
          component: (resolve) =>
            require(["@/views/grow-group/index"], resolve),
        },
      ],
    },

    {
      path: "/growthValues",
      name: "growth-values",
      component: (resolve) => require(["@/views/growth-values/index"], resolve),
    },
    {
      path: "/login",
      name: "login",
      component: (resolve) => require(["@/views/login/index"], resolve),
    },
    {
      path: "/identity",
      name: "identity",
      component: (resolve) => require(["@/views/identity/index"], resolve),
    },
    {
      path: "/information",
      name: "information",
      component: (resolve) => require(["@/views/information/index"], resolve),
    },
    {
      path: "/myInformation",
      name: "myInformation",
      component: (resolve) => require(["@/views/information/index"], resolve),
    },
    {
      path: "/testType",
      name: "test-type",
      component: (resolve) =>
        require(["@/views/test-center/test-type"], resolve),
    },
    {
      path: "/testDetail",
      name: "test-detail",
      component: (resolve) =>
        require(["@/views/test-center/test-detail"], resolve),
    },
    {
      path: "/test",
      name: "test",
      component: (resolve) => require(["@/views/test-center/test"], resolve),
    },
    {
      path: "/privacyPassword",
      name: "privacy-password",
      component: (resolve) =>
        require(["@/views/test-center/privacy-password"], resolve),
    },
    {
      path: "/growClub",
      name: "grow-club",
      component: (resolve) =>
        require(["@/views/test-center/grow-club"], resolve),
    },
    {
      path: "/result",
      name: "result",
      component: (resolve) => require(["@/views/test-center/result"], resolve),
    },
    {
      path: "/template",
      name: "template",
      component: (resolve) =>
        require(["@/views/test-center/template"], resolve),
    },
    {
      path: "/emotion",
      name: "emotion",
      component: (resolve) => require(["@/views/grow-group/emotion"], resolve),
    },
    {
      path: "/happySpace",
      name: "happy-space",
      component: (resolve) =>
        require(["@/views/grow-group/happy-space"], resolve),
    },
    {
      path: "/happySpaceDetail",
      name: "happy-space-detail",
      component: (resolve) =>
        require(["@/views/grow-group/happy-space-detail"], resolve),
    },
    {
      path: "/happySpaceTab",
      name: "happy-space-tab",
      component: (resolve) =>
        require(["@/views/grow-group/happy-space-tab"], resolve),
    },
    {
      path: "/happySpaceVideo",
      name: "happy-space-video",
      component: (resolve) =>
        require(["@/views/video/happy-space-video"], resolve),
    },
    {
      path: "/loadingPage",
      name: "loading-page",
      component: (resolve) => require(["@/views/video/loading-page"], resolve),
    },
    {
      path: "/gameIndex",
      name: "gameIndex",
      component: (resolve) => require(["@/views/game/index"], resolve),
    },
    {
      path: "/game",
      name: "game",
      component: (resolve) => require(["@/views/game/game"], resolve),
    },
    {
      path: "/course",
      name: "course",
      component: (resolve) => require(["@/views/parent-course/index"], resolve),
    },
    {
      path: "/search",
      name: "search",
      component: (resolve) => require(["@/views/search/index"], resolve),
    },
    {
      path: "/basicInfor",
      name: "basic-infor",
      component: (resolve) =>
        require(["@/views/basic-information/index"], resolve),
    },
    {
      path: "/video",
      name: "video",
      component: (resolve) => require(["@/views/video/index"], resolve),
    },
    {
      path: "/secondPlate",
      name: "second-plate",
      component: (resolve) =>
        require(["@/views/parent-course/widget/second-plate/index"], resolve),
    },
    {
      path: "/thirdPlate",
      name: "third-plate",
      component: (resolve) =>
        require(["@/views/parent-course/widget/third-plate/index"], resolve),
    },
    {
      path: "/coursePlate/:id",
      name: "course-plate",
      component: (resolve) =>
        require([
          "@/views/parent-course/widget/course-plate/course-plate.vue",
        ], resolve),
    },
    {
      path: "/coursePlateNopay/:id",
      name: "course-plate-nopay",
      component: (resolve) =>
        require([
          "@/views/parent-course/widget/course-plate/course-plate-nopay.vue",
        ], resolve),
    },
    {
      path: "/demo",
      name: "video2",
      component: (resolve) => require(["@/components/video/demo"], resolve),
    },
    {
      path: "/jigsawIndex",
      name: "jigsaw-index",
      component: (resolve) => require(["@/views/jigsaw/index"], resolve),
    },
    {
      path: "/jigsaw",
      name: "jigsaw",
      component: (resolve) => require(["@/views/jigsaw/jigsaw"], resolve),
    },
    {
      path: "/myIntegral",
      name: "my-integral",
      component: (resolve) =>
        require(["@/views/integral/my-integral"], resolve),
    },
    {
      path: "/integralRecord",
      name: "integral-record",
      component: (resolve) =>
        require(["@/views/integral/integral-record"], resolve),
    },
    {
      path: "/integralRule",
      name: "integral-rule",
      component: (resolve) =>
        require(["@/views/integral/integral-rule"], resolve),
    },
    {
      path: "/artical",
      name: "artical",
      component: (resolve) =>
        require(["@/views/parent-course/widget/artical/index"], resolve),
    },
    {
      path: "/familyArchives", //家庭档案
      name: "family-archives",
      component: (resolve) =>
        require(["@/views/family-archives/index"], resolve),
    },

    {
      path: "/myOrder", //我的订单
      name: "myOrder",
      component: (resolve) => require(["@/views/settings/myOrder"], resolve),
    },
    {
      path: "/myOrderDetail", //我的订单详情
      name: "myOrderDetail",
      component: (resolve) =>
        require(["@/views/settings/myOrderDetail"], resolve),
    },
    {
      path: "/offlineOrderDetail", //线下课程订单详情
      name: "offlineOrderDetail",
      component: (resolve) =>
        require(["@/views/settings/offline-order-detail"], resolve),
    },
    {
      path: "/invoice", //发票
      name: "invoice",
      component: (resolve) => require(["@/views/settings/invoice"], resolve),
    },
    {
      path: "/applyInvoice", //申请发票
      name: "applyInvoice",
      component: (resolve) =>
        require(["@/views/settings/applyInvoice"], resolve),
    },
    {
      path: "/invoiceHistory", //开票历史
      name: "invoiceHistory",
      component: (resolve) =>
        require(["@/views/settings/invoiceHistory"], resolve),
    },
    {
      path: "/invoiceDetail", //开票详情
      name: "invoiceDetail",
      component: (resolve) =>
        require(["@/views/settings/invoiceDetail"], resolve),
    },
    {
      path: "/adressList", //收货地址
      name: "adressList",
      component: (resolve) => require(["@/views/settings/adressList"], resolve),
    },
    {
      path: "/addAdress", //新增、编辑收货地址
      name: "addAdress",
      component: (resolve) => require(["@/views/settings/addAdress"], resolve),
    },
    {
      path: "/orderConfirm", //线上课订单确认
      name: "orderConfirm",
      component: (resolve) =>
        require(["@/views/settings/orderConfirm"], resolve),
    },
    {
      path: "/outlineOrderConfirm", //线下课订单确认
      name: "outlineOrderConfirm",
      component: (resolve) =>
        require(["@/views/settings/outlineOrderConfirm"], resolve),
    },
    {
      path: "/paymentCallback", //支付成功回调页面
      name: "paymentCallback",
      component: (resolve) =>
        require(["@/views/settings/paymentCallback"], resolve),
    },
    {
      path: "/paymentCallbackJump", //支付回调页面
      name: "paymentCallbackJump",
      component: (resolve) =>
        require(["@/views/settings/paymentCallbackJump"], resolve),
    },
    {
      path: "/setting", //设置
      name: "setting",
      component: (resolve) => require(["@/views/settings/index"], resolve),
    },
    {
      path: "/changePassword", //修改密码
      name: "change-password",
      component: (resolve) =>
        require(["@/views/settings/change-password"], resolve),
    },
    {
      path: "/replacePhone", //更换绑定手机号
      name: "replace-phone",
      component: (resolve) =>
        require(["@/views/settings/replace-phone"], resolve),
    },
    {
      path: "/informedConsent", //知情同意书
      name: "informed-consent",
      component: (resolve) =>
        require(["@/views/settings/informed-consent"], resolve),
    },
    {
      path: "/informedConsentDetail", //知情同意书详情
      name: "informed-consent-detail",
      component: (resolve) =>
        require(["@/views/settings/informed-consent-detail"], resolve),
    },
    // {
    //   path: "/privacyManagement", //隐私管理
    //   name: "privacy-management",
    //   component: (resolve) =>
    //     require(["@/views/settings/privacy-management"], resolve),
    // },
    {
      path: "/privacyAgreement", //隐私管理
      name: "privacy-agreement",
      component: (resolve) =>
        require(["@/views/settings/privacy-agreement"], resolve),
    },
    {
      path: "/cancel", //注销账户
      name: "cancel",
      component: (resolve) => require(["@/views/settings/cancel"], resolve),
    },
    {
      path: "/privacyManagementDetail", //隐私管理详情
      name: "privacy-management-detail",
      component: (resolve) =>
        require(["@/views/settings/privacy-management-detail"], resolve),
    },
    {
      path: "/childrenFile", //儿童档案
      name: "children-file",
      component: (resolve) => require(["@/views/children-file/index"], resolve),
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    // ...
    return { x: 0, y: 0 };
  },
});

// $router.beforeEach((to, from, next) => {
//   if (to.path != "/login") {
//     registerWxConfig();
//   }
//   next();
// });
export default $router;
